import React, { useEffect, useState } from "react";
import { useAIWorkflowContext } from "../../../../context/ai-workflow.context";
import { NodeType } from "../../../../helper/constant";
import { useReactFlow } from "@xyflow/react";
import { useAIModelContext } from "../../../../context/ai-model.context";

const OutputNodeConfig = (props) => {
    const [forms, setForms] = useState({ prompt: '' });
    const { setNodes } = useReactFlow();
    const { updateRightMenu } = useAIModelContext();
    const { selectedNode, workflowEdit } = useAIWorkflowContext();

    useEffect(() => {
        if (selectedNode && selectedNode.data) {
            setForms({
                prompt: selectedNode.data.prompt
            });
        }

    }, [selectedNode]);

    const renderPrompt = () => {
        return (
            <div className="d-flex justify-content-between align-items-center"
            >
                <textarea
                    className={`form-control`}
                    style={{ minHeight: 100 }}
                    placeholder="Prompt"
                    value={forms.prompt}
                    onChange={(e) => setForms({ ...forms, prompt: e.currentTarget.value })}
                />
            </div>
        )
    }

    const onFormSubmit = e => {
        e.preventDefault();
        const { id } = selectedNode;
        setNodes((nodes) => nodes.map((node) =>
            node.id === id
                ? { ...node, data: { ...node.data, ...forms } }
                : node
        ));
        updateRightMenu(false);
    }

    const renderSaveButton = () => {
        return (
            <div className="form-group">
                <button
                    type="submit"
                    className="btn2 btn radious-0 w-100 f-13 text-uppercase py-2 font15 fontweight600">
                    save
                </button>
            </div>
        )
    }
    const renderConfigForm = () => {
        return (
            <form className="d-flex flex-column gap-2" onSubmit={onFormSubmit} noValidate>
                {renderPrompt()}
                {renderSaveButton()}
            </form>
        )
    }

    const renderConfigrationStatus = () => {
        return (
            <div className="d-flex flex-column flex-wrap gap-1">
                <p className="p-0 m-0">
                    <span className="text-black">Prompt :</span>
                    <span className="text-secondary capitalize"> {selectedNode.data.prompt}</span>
                </p>
            </div>
        )
    }

    const render = () => {
        return (
            <div className="d-flex flex-column flex-wrap gap-3 pt-3">
                <h5>Output Node Configuration</h5>
                {workflowEdit ? renderConfigForm() : renderConfigrationStatus()}
            </div>
        )
    }
    return render();

}

export default OutputNodeConfig